import { Roles } from 'constants/roles';

export const isDowngradeRole = (currentRole, newRole) => {
  return (
    [Roles.Owner, Roles.Admin].includes(currentRole) &&
    [Roles.BO, Roles.SO, Roles.Viewer, Roles.Reporter].includes(newRole)
  );
};
